module.exports = __webpack_public_path__ + "static/media/tweeter-logo.899775d3.svg";